import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/tokyu-web/app/(pages)/maintenance/Maintenance.tsx");
